import React from 'react';

import classNames from 'classnames';

import { A } from 'wanderu-component-react-router-link';
import {
    Layout,
    Logo,
    InstagramIcon,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    FlipboardIcon,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

// eslint-disable-next-line import/no-named-as-default
import LinkTable from '../LinkTable/LinkTable';

import styles from './Footer.scss';

import type { TFunction } from 'i18next';

interface FooterProps {
    buildId?: string;
    className?: string;
    isExternal?: boolean;
    limitLinkFlow?: boolean;
    region?: string;
    t: TFunction;
    version?: string;
}

function Footer({
    buildId = 'none',
    className = '',
    isExternal = false,
    limitLinkFlow = false,
    region = 'none',
    t,
    version = '0.0.0',
}: FooterProps) {
    return (
        <footer
            className={classNames(
                className,
                styles.footer,
            )}
            data-id="site-footer">
            <LinkTable limitLinkFlow={limitLinkFlow} />
            {!limitLinkFlow && (
                <Layout>
                    <div className={styles.social} data-testid="social">
                        <A
                            aria-label="Instagram"
                            href="https://instagram.com/wanderu"
                            target="_blank"
                        >
                            <InstagramIcon
                                alt="Instagram"
                                className={styles.socialIcon}
                            />
                        </A>
                        <A
                            aria-label="Facebook"
                            href="https://facebook.com/GoWanderu"
                            target="_blank"
                        >
                            <FacebookIcon
                                alt="Facebook"
                                className={styles.socialIcon}
                            />
                        </A>
                        <A
                            aria-label="Twitter"
                            href="https://twitter.com/gowanderu"
                            target="_blank"
                        >
                            <TwitterIcon
                                alt="Twitter"
                                className={styles.socialIcon}
                            />
                        </A>
                        <A
                            aria-label="LinkedIn"
                            href="https://www.linkedin.com/organization-guest/company/wanderu-inc"
                            target="_blank"
                        >
                            <LinkedinIcon
                                alt="LinkedIn"
                                className={styles.socialIcon}
                            />
                        </A>
                        <A
                            aria-label="FlipBoard"
                            href="https://flipboard.com/@wanderu/"
                            target="_blank"
                        >
                            <FlipboardIcon
                                alt="Flipboard"
                                className={styles.socialIcon}
                            />
                        </A>
                    </div>
                </Layout>
            )}
            <Layout className={styles.legal} data-testid="legal">
                <div className={styles.logoContainer}>
                    <Logo
                        className={styles.logo}
                        isExternal={isExternal}
                        link
                    />
                    <span className={styles.copyright}>
                        {t<string>('footer-copyright', { year: new Date().getFullYear() })}
                    </span>
                </div>
                <div className={`${styles.versionString}`}>
                    version {version} | dc {region} | build {buildId}
                </div>
            </Layout>
        </footer>
    );
}

export { Footer };
export default localize(Footer, ['t'], 'baseApp');
